module.exports = __webpack_public_path__ + "img/123icon.3b24f269.jpg";